/* React */
import React from "react";

/* React Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Components */
import OutlineButton from "src/components/shared/buttons/outline-button/OutlineButton";

/* Stylesheet */
import styles from "./OperatorContainer.module.scss";

/* Interfaces */
import { Operator } from "src/shared/interfaces/custom-cohorts/Operator";

import {
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface OperatorContainerProps {
  isSegment: (
    segment: BasicProps | LogicalProps
  ) => segment is LogicalProps;
  segments: BasicProps | LogicalProps;
  disabled: boolean;
  handleSegments: (
    segment: BasicProps | LogicalProps
  ) => void;
}

const OperatorContainer: React.FC<
  OperatorContainerProps
> = ({ isSegment, segments, disabled, handleSegments }) => {
  const addConditionToSegment = (
    operator: Operator,
    condition: BasicProps | LogicalProps
  ) => {
    if (!segments) {
      handleSegments({
        operator,
        conditions: [condition],
      });
    }

    if (isSegment(segments)) {
      const conditions =
        segments.operator === operator
          ? [...segments.conditions, condition]
          : [
              ...segments.conditions,
              { operator, conditions: [condition] },
            ];
      handleSegments({
        ...segments,
        conditions: conditions,
      });
    }
  };

  /**
   * Get the initial feature type, which is the first feature in the list.
   * This is required when changing main condition.
   */
  const featureTypesState = useSelector(
    (state: RootState) => state.featureTypes
  );
  const { data } = featureTypesState;
  const initialFeatureType = data?.[0];

  return (
    <div className={styles.operator_container}>
      {!segments ? (
        <OutlineButton
          scssProps={{
            color: "var(--ion-color-dark-primary)",
            textTransform: "uppercase",
          }}
          label={Operator.BASIC as string}
          disabled={disabled}
          onClick={() => {
            handleSegments(initialFeatureType!);
          }}
        />
      ) : undefined}
      <OutlineButton
        scssProps={{
          color: "var(--ion-color-primary)",
          textTransform: "uppercase",
        }}
        label={Operator.AND as string}
        disabled={disabled}
        onClick={() =>
          addConditionToSegment(
            Operator.AND,
            initialFeatureType!
          )
        }
      />
      <OutlineButton
        scssProps={{
          color: "var(--ion-color-secondary)",
          textTransform: "uppercase",
        }}
        label={Operator.OR as string}
        disabled={disabled}
        onClick={() =>
          addConditionToSegment(
            Operator.OR,
            initialFeatureType!
          )
        }
      />
    </div>
  );
};

export default OperatorContainer;
